import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c7ytqjae3f: FaireBrandEntity = {
  token: "b_c7ytqjae3f",
  type: "brand",
  name: "Nokki Farm",
  avatarUrl:
    "https://cdn.faire.com/fastly/8f33555c262c77c466386ec7d8aa9656e70cb2a8b8dab3e01936f52700074fcf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9ba69eca2a92bb25b057da9bc514fc0ec1c703b57cbfc27b12d11c68068dcb29.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8f33555c262c77c466386ec7d8aa9656e70cb2a8b8dab3e01936f52700074fcf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9ba69eca2a92bb25b057da9bc514fc0ec1c703b57cbfc27b12d11c68068dcb29.png",
  location: "San Jose, CA, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Nikky Do is a proud mother of two wonderful children, Zoey and Jax. Her journey into entrepreneurship was inspired by a deeply personal passion: providing wholesome and delicious snacks for children and families alike. It all began when her daughter, Zoey, started preschool, and she found herself on a quest to find healthy fruit snacks that rivaled the crunch of traditional chips as Zoey always asks for something crunchy.\n\nInspired by this quest and the recent arrival of her second child, she embarked on a new venture: founding a healthy fruit snack company. Growing up in Vietnam, she was blessed to savor the vibrant flavors of tropical fruits firsthand. Now, she is committed to sharing these exquisite tastes with families here, in their purest and highest quality forms. She's chosen freeze-dried fruit as her medium, as it preserves up to 97% of the nutrients and natural flavors, offering a nutritious and delectable alternative to fresh fruits. Through Nokki Farm, she aims to provide families with the next best thing to fresh fruits, ensuring they can enjoy wholesome snacks without compromising on taste or nutrition.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.629Z",
    importedBy: "entity-db-cli",
  },
};
